import React, { useState, useEffect } from "react";
import { DataStore } from "aws-amplify";
import { Grid, View, Heading, Text, Button } from "@aws-amplify/ui-react";
// import { useTheme } from "@aws-amplify/ui-react";
import { useNavigate, useLocation } from "react-router-dom";
import ProductUpdateForm from "./ProductUpdateForm";
import { Product } from "../models";
// import { styled } from "@mui/material/styles";
// import Paper from "@mui/material/Paper";

// const ItemButton = styled(Paper)(({ theme }) => ({
//   textAlign: "center",
//   backgroundColor: "inherit",
// }));

export function EditProductPage() {
  // const { tokens } = useTheme();
  const location = useLocation();
  const itemId = location.state.itemId;

  const [currentProduct, setCurrentProduct] = useState();

  let navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleFormSubmitSuccess = () => navigate("/edit-product-confirmation");

  const handleFormSubmitError = () => {
    throw new Error("HTTP error!");
  };

  useEffect(() => {
    const sub = DataStore.observeQuery(Product, (c) => c.id.eq(itemId)).subscribe(({ items }) => {
      setCurrentProduct(items[0]);
    });
    return () => sub.unsubscribe();
  }, [itemId]);

  return (
    <div
      style={{
        fontFamily: "Poppins, Arial, sans-serif",
        minHeight: "100vh",
        paddingTop: "4em",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Scrollable Content */}
      <div
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "2em",
        }}
      >
        <Grid
          templateColumns="1fr"
          gap="2em"
          style={{
            maxWidth: "800px",
            width: "100%",
            backgroundColor: "#ffffff", // Card background remains white
            borderRadius: "16px",
            boxShadow: "0px 8px 24px rgba(0, 0, 0, 0.15)", // Stronger shadow for depth
            padding: "2em",
            margin: "0 auto",
          }}
        >
          {/* Section: Header */}
          <View style={{ textAlign: "center", paddingBottom: "1em" }}>
            <Heading
              level={2}
              style={{
                fontSize: "2em", // Adjusted for better scaling
                fontWeight: "700",
                color: "#333", // Darker font for better readability
                marginBottom: "0.5em",
              }}
            >
              Modifica prodotto
            </Heading>
            <Text
              style={{
                fontSize: "1.1em",
                color: "#555", // Secondary color for subtext
                lineHeight: "1.6",
              }}
            >
              Aggiorna le informazioni del tuo prodotto nel modulo sottostante.
            </Text>
          </View>

          {/* Section: Form */}
          <View
            style={{
              backgroundColor: "#f9f9f9", // Light gray for contrast
              padding: "2em",
              borderRadius: "12px",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
            }}
          >
            {currentProduct ? (
              <ProductUpdateForm
                onSuccess={handleFormSubmitSuccess}
                onError={handleFormSubmitError}
                product={currentProduct}
              />
            ) : (
              <Text style={{ textAlign: "center", fontSize: "1em" }}>
                Caricamento in corso...
              </Text>
            )}
          </View>

          <View style={{ textAlign: "center", paddingTop: "1em" }}>
            <Button
              onClick={() => navigate("/home/producer")}
              style={{
                backgroundColor: "#000", // Solid black for high contrast
                color: "#fff",
                borderRadius: "4px", // Rounded edges for a modern look
                width: "200px", // Adjusted width for consistency
                padding: "0.75em 1em", // Balanced padding
                fontSize: "1em",
                fontWeight: "600",
                transition: "all 0.3s ease", // Smooth hover transition
              }}
              onMouseEnter={(e) =>
                (e.target.style.backgroundColor = "#444") // Darken on hover
              }
              onMouseLeave={(e) =>
                (e.target.style.backgroundColor = "#000") // Restore on leave
              }
            >
              Torna ai prodotti
            </Button>
          </View>
        </Grid>
      </div>
    </div>
  );
}

export function EditProduct() {
  return <EditProductPage />;
}
